module.exports = __webpack_public_path__ + "static/media/ModelPhoto1.3b0260b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/ModelPhoto1.jpg
// module id = 208
// module chunks = 0